module.exports = __webpack_public_path__ + "static/media/sf_2400.02f188086ec2de51fbfeb7b7899df5ec.png";